import type { ReactNode } from 'react';
import { BackgroundGradients } from './BackgroundGradients';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="h-[100dvh] bg-slate-900 text-white font-sans selection:bg-indigo-500 selection:text-white overflow-hidden flex">
      <BackgroundGradients />
      {children}
    </div>
  );
}
